import { MutationObserverOptions, useMutation } from 'react-query';

import { SetSyndicateRateL2Input, SetSyndicateRateL2Output, queryClient, setSyndicateRateL2 } from 'clients/api';
import { useVaiControllerContract, useUmiTokenContract, useUmiVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

type Options = MutationObserverOptions<
    SetSyndicateRateL2Output,
  Error,
  Omit<SetSyndicateRateL2Input, 'umiControllerContract'>
>;

const useSetSyndicateRateL2 = (options?: Options) => {
  const umiControllerContract = useUmiVaultContract();

  return useMutation(
    FunctionKey.SET_SYNDICATERATEL2,
    (params: Omit<SetSyndicateRateL2Input, 'umiControllerContract'>) =>
        setSyndicateRateL2({
          umiControllerContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        // Invalidate queries related to fetching the user minted VAI amount
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_USERINFO);
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useSetSyndicateRateL2;
